import { Box, Grid, Theme } from "@mui/material";
import { navigationData as NavigationData, PaginationObj, SortingObj } from "../types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { schemeDetails } from "../../../redux-store/actions/alternates";
import { RootStateType } from "../../../redux-store/reducers";
import { AlternativeSchemeRes } from "../../../redux-store/types/alternative";
import CustomTable from "../common/customTable";
import { SchemeDetailsComponet, schemeDetailsTableHeader } from "./component/AlternativeTable";
import { useHistory } from "react-router";
import { USER_ROLES } from "../../../utils/constant";
import { isRMLikeRole } from "../../../utils/utilityFunctions";


export default function AlternatesSchemeDetails(props: NavigationData): JSX.Element {
    const { clientCode = '' } = props
    const dispatch = useDispatch()
    const { id: { investorClientId, iwappRmId , clientInterfaceCode }, selectedPortfiolio: { selectedPortfolio }, auth: { role = '' } } = useSelector((state: RootStateType) => state)
    const { investorRmId = "" } = useSelector((state: RootStateType) => state.sessionData)
    const history = useHistory()
    const { pathname } = history.location

    // state
    const [schemeData, setSchemeData] = useState<AlternativeSchemeRes>({} as AlternativeSchemeRes)
    const [isLoading, setIsLoading] = useState(false)
    const [sortingObj, setSortingObj] = useState<SortingObj>({
        order: "asc",
        orderBy: ""
    })
    const [page, setPage] = useState<PaginationObj>({
        currentPage: 1,
        rowsPerPage: 5,
        totalRows: 0
    })

    const IsInvestor = pathname.split('/').filter(item => item !== '')[0] === 'investor-dashboard'


    useEffect(() => {
        schemeApi()
    }, [])

    const schemeApi = async (page = 1, rowsPerPage = 5, sortItem = "schemeName", order = "asc") => {
        setIsLoading(true)
        const payload = {
            "rmId": pathname.includes('product') || pathname.includes('investor-profile') ? `${iwappRmId}` : `${investorRmId}`,
            "sortItem": sortItem, //default value
            "order": order,//default value
            "currentPage": page,
            "rowsPerPage": rowsPerPage,
            "assetGroup": "AL", 
            "clientCode": isRMLikeRole(role) ? clientCode : investorClientId,
            "portfolioId": !pathname.includes('product') ? selectedPortfolio.value || clientInterfaceCode : ""
        }
        const res = await dispatch(schemeDetails(payload)) as unknown as AlternativeSchemeRes
        if (res.isSuccess) {
            setSchemeData(res)
        }
        setIsLoading(false)
    }


    const handleTableSorting = (id: string, orderType: "asc" | "desc") => {
        console.log(id, orderType)
        setSortingObj({ order: orderType, orderBy: id })
        schemeApi(page.currentPage, page.rowsPerPage, id, orderType)
    }

    const handlePageChange = (event: any, curentPage: number) => {
        console.log("page", curentPage)
        setPage(pre => ({ ...pre, currentPage: curentPage + 1 }))
        schemeApi(curentPage + 1, page.rowsPerPage, sortingObj.orderBy, sortingObj.order)
    }

    const handleRowChange = (event: any, row: number) => {
        console.log("row", event.target.value)
        setPage(pre => ({ ...pre, rowsPerPage: event.target.value }))
        schemeApi(page.currentPage, event.target.value, sortingObj.orderBy, sortingObj.order)
    }

    return (
        <Box sx={(theme: Theme) => ({
            borderRadius: '20px',
            padding: '25px 30px 45px 30px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
            background: theme.palette.common.white,
            height: '100%'
        })}>
            <Box mt={'20px'} width={'100%'}>
                <CustomTable
                    loadingRowsNum={5}
                    isLoading={isLoading}
                    tableBody={
                        <SchemeDetailsComponet
                            tableBodyData={schemeData.result || []}
                            isLoading={isLoading}
                        />
                    }
                    tableData={schemeData.result || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },

                    }}
                    tableHeaderData={schemeDetailsTableHeader}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    handleSort={handleTableSorting as any}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    tableDataCount={schemeData?.totalLength}
                    order={sortingObj.order}
                    orderBy={sortingObj.orderBy}
                    isPaginationVisible={true}
                    rowsPerPage={page.rowsPerPage}
                    currentPage={page.currentPage - 1}
                    rowsPerPageOptions={[5, 10, 15]}
                    handlePageChange={handlePageChange as any}
                    handleRowsPerPageChange={handleRowChange as any}
                />
            </Box>
        </Box>
    )
}